// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-shell {
  display: grid;
  gap: 1.5rem;
}
.page-shell .page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}
.page-shell .page-header > div {
  width: 100%;
}
.page-shell .page-header h1 {
  margin: 0 0 0.25rem;
  font-size: 1.6rem;
  font-weight: 700;
  color: #1a2a38;
}
.page-shell .page-header p {
  margin: 0;
  font-size: 0.9rem;
  color: #56636f;
}
.page-shell .page-header .btn.primary {
  display: flex;
  width: fit-content;
  margin: 0.75rem auto 0;
}

.table-shell {
  overflow-x: auto;
}
.table-shell table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;
}
.table-shell table th,
.table-shell table td {
  padding: 0.65rem 0.85rem;
  text-align: left;
  border-bottom: 1px solid #e0e7ee;
}
.table-shell table th {
  font-weight: 600;
  background: #f4f7fa;
  color: #445260;
}
.table-shell table tbody tr:hover {
  background: #f9fbfd;
}

.actions-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
}

.action-icon {
  cursor: pointer;
  border-radius: 4px;
  padding: 0.2rem;
  transition: background 0.15s ease;
}
.action-icon:focus-visible {
  outline: 2px solid #0073e6;
  outline-offset: 2px;
}

.edit-icon {
  color: #334d6e;
}
.edit-icon:hover {
  background: #f0f4f8;
}

.delete-icon {
  color: #56636f;
}
.delete-icon:hover {
  background: #f0f4f8;
}

.empty-row {
  color: #8a97a3;
  font-style: italic;
  text-align: center !important;
  padding: 2rem !important;
}

.error.banner {
  color: #d9363e;
  background: #fdf0f0;
  border: 1px solid #f5c6c8;
  border-radius: 4px;
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  margin: 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s ease;
  text-decoration: none;
}
.btn.primary {
  background: #0073e6;
  color: #fff;
  border-color: #0073e6;
}
.btn.primary:hover {
  background: #005bbf;
}
.btn.secondary {
  background: #fff;
  color: #334d6e;
  border-color: #c7d2da;
}
.btn.secondary:hover {
  background: #f0f4f8;
}
.btn.danger {
  background: #fff;
  color: #d9363e;
  border-color: #d9363e;
}
.btn.danger:hover {
  background: #fdf0f0;
}
.btn.small {
  padding: 0.35rem 0.65rem;
  font-size: 0.85rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/custom-test-definitions/list/test-definitions-list.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AACJ;AACI;EACE,WAAA;AACN;AAEI;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAAN;AAGI;EACE,SAAA;EACA,iBAAA;EACA,cAAA;AADN;AAII;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;AAFN;;AAOA;EACE,gBAAA;AAJF;AAME;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAJJ;AAMI;;EAEE,wBAAA;EACA,gBAAA;EACA,gCAAA;AAJN;AAOI;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AALN;AAQI;EACE,mBAAA;AANN;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AARF;;AAWA;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AARF;AAUE;EACE,0BAAA;EACA,mBAAA;AARJ;;AAYA;EACE,cAAA;AATF;AAWE;EACE,mBAAA;AATJ;;AAaA;EACE,cAAA;AAVF;AAYE;EACE,mBAAA;AAVJ;;AAcA;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,wBAAA;AAXF;;AAcA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,SAAA;AAXF;;AAcA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,iCAAA;EACA,qBAAA;AAXF;AAaE;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAXJ;AAaI;EACE,mBAAA;AAXN;AAeE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAbJ;AAeI;EACE,mBAAA;AAbN;AAiBE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAfJ;AAiBI;EACE,mBAAA;AAfN;AAmBE;EACE,wBAAA;EACA,kBAAA;AAjBJ","sourcesContent":[".page-shell {\n  display: grid;\n  gap: 1.5rem;\n\n  .page-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n    flex-wrap: wrap;\n\n    > div {\n      width: 100%;\n    }\n\n    h1 {\n      margin: 0 0 0.25rem;\n      font-size: 1.6rem;\n      font-weight: 700;\n      color: #1a2a38;\n    }\n\n    p {\n      margin: 0;\n      font-size: 0.9rem;\n      color: #56636f;\n    }\n\n    .btn.primary {\n      display: flex;\n      width: fit-content;\n      margin: 0.75rem auto 0;\n    }\n  }\n}\n\n.table-shell {\n  overflow-x: auto;\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.92rem;\n\n    th,\n    td {\n      padding: 0.65rem 0.85rem;\n      text-align: left;\n      border-bottom: 1px solid #e0e7ee;\n    }\n\n    th {\n      font-weight: 600;\n      background: #f4f7fa;\n      color: #445260;\n    }\n\n    tbody tr:hover {\n      background: #f9fbfd;\n    }\n  }\n}\n\n.actions-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n}\n\n.action-icon {\n  cursor: pointer;\n  border-radius: 4px;\n  padding: 0.2rem;\n  transition: background 0.15s ease;\n\n  &:focus-visible {\n    outline: 2px solid #0073e6;\n    outline-offset: 2px;\n  }\n}\n\n.edit-icon {\n  color: #334d6e;\n\n  &:hover {\n    background: #f0f4f8;\n  }\n}\n\n.delete-icon {\n  color: #56636f;\n\n  &:hover {\n    background: #f0f4f8;\n  }\n}\n\n.empty-row {\n  color: #8a97a3;\n  font-style: italic;\n  text-align: center !important;\n  padding: 2rem !important;\n}\n\n.error.banner {\n  color: #d9363e;\n  background: #fdf0f0;\n  border: 1px solid #f5c6c8;\n  border-radius: 4px;\n  padding: 0.65rem 1rem;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  font-size: 0.92rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background 0.15s ease;\n  text-decoration: none;\n\n  &.primary {\n    background: #0073e6;\n    color: #fff;\n    border-color: #0073e6;\n\n    &:hover {\n      background: #005bbf;\n    }\n  }\n\n  &.secondary {\n    background: #fff;\n    color: #334d6e;\n    border-color: #c7d2da;\n\n    &:hover {\n      background: #f0f4f8;\n    }\n  }\n\n  &.danger {\n    background: #fff;\n    color: #d9363e;\n    border-color: #d9363e;\n\n    &:hover {\n      background: #fdf0f0;\n    }\n  }\n\n  &.small {\n    padding: 0.35rem 0.65rem;\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
